import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/help")({
  component: () => (
    <div className="flex h-screen animate-pulse">
      <div className="hidden md:block w-72 border-r bg-muted/30 p-4" />
      <main className="flex-1 p-8">
        <div className="h-8 w-48 bg-muted rounded mb-4" />
        <div className="h-4 w-full bg-muted rounded mb-2" />
        <div className="h-4 w-3/4 bg-muted rounded" />
      </main>
    </div>
  ),
});
